<template>
  <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
    <div v-if="temPermissao('segmento-pre-vestibular')" class="main pb-4">
      <b-container fluid="lg">
        <b-card class="shadow-sm">
          <b-nav class="nav-books" tabs fill>
            <b-nav-item @click="setActive(index)" :class="{ active: activeIndex === index }"
              :active="activeIndex === index" v-for="(menu, index) in lists" :key="index">
              <i :class="menu.iconClass"></i>
              <span class="mr-auto">{{ menu.name }}</span>
            </b-nav-item>
          </b-nav>

          <div v-for="(menu, index) in lists" :key="index">
            <b-collapse @show="setActive(index)" @hide="clearActive(index)" :visible="activeIndex === index">
              <div class="mt-3" v-if="menu.turmas">
                <b-card v-for="(turma, idx) in menu.turmas" :key="idx" class="border-0 shadow-none" no-body>
                  <b-button block @click="toggleCollapse('resolucaoCpv', idx)" variant="link"
                    class="button-toggle border-light p-3 text-decoration-none" v-if="menu.name == 'Resoluções'">
                    <div class="d-flex align-items-center justify-content-baseline">
                      <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                        turma.otherName }})</span></span>
                      <i :class="collapsedStates.resolucaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                    </div>
                  </b-button>
                  <b-button block @click="toggleCollapse('colecaoCpv', idx)" variant="link"
                    class="button-toggle border-light p-3 text-decoration-none" v-if="menu.name == 'Coleção CPV'">
                    <div class="d-flex align-items-center justify-content-baseline">
                      <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                        turma.otherName }})</span></span>
                      <i :class="collapsedStates.colecaoCpv[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                    </div>
                  </b-button>
                  <b-button block @click="toggleCollapse('exerciciosRegionais', idx)" variant="link"
                    class="button-toggle border-light p-3 text-decoration-none"
                    v-if="menu.name == 'Exercícios Regionais'">
                    <div class="d-flex align-items-center justify-content-baseline">
                      <span class="mr-auto"><strong>{{ turma.name }}</strong> <span v-if="turma.otherName != ''">- ({{
                        turma.otherName }})</span></span>
                      <i
                        :class="collapsedStates.exerciciosRegionais[idx] ? 'fa-solid fa-minus' : 'fa-solid fa-plus'"></i>
                    </div>
                  </b-button>
                  <div v-if="menu.name == 'Coleção CPV'">
                  <b-collapse v-model="collapsedStates.colecaoCpv[idx]">
                    <div v-for="(book, idx) in turma.books" :key="idx">
                      <router-link :to="{
                          name: 'render-conteudo-exclusivo',
                          params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                          query: { material: formatParam(book.description) },
                        }">
                          <b-card no-body class="p-3 text-dark">
                            <div class="d-flex aling-items-center">
                              <i :class="book.iconClass" class="d-flex align-items-center"></i>
                              <span class="mr-1"><strong>{{ book.book }}</strong></span> - <span class="ml-1">{{ book.name }}</span>
                            </div>
                          </b-card>
                        </router-link>
                    </div>
                  </b-collapse>
                </div>
                <div v-if="menu.name == 'Resoluções'">
                  <b-collapse v-model="collapsedStates.resolucaoCpv[idx]">
                    <b-card class="p-2 border border-light" no-body>
                      <b-nav tabs fill small>
                        <b-nav-item v-show="turma.books.bookName !== ''" link-classes="nav-cadernos"
                          v-for="(book, idx) in turma.books" :key="idx" :active="activeTab === idx"
                          @click="activeTab = idx">
                          <span>{{ book.bookName }}</span>
                        </b-nav-item>
                      </b-nav>
                      <b-card-body>
                        <div v-if="turma.books[activeTab]">
                          <div v-for="(apostila, index) in turma.books[activeTab].apostila" :key="index">
                            <router-link :to="{
                              name: 'render-conteudo-exclusivo',
                              params: { paramsForUrl: apostila.linkFree || '', nomeApostila: apostila.name || '' },
                              query: { material: formatParam(apostila.description) }
                            }">
                              <transition type="animation" enter-active-class="animated animate__fadeIn"
                                leave-active-class="animated animate__fadeOut" appear mode="out-in">
                                <b-card no-body class="p-3 text-dark">
                                  <div class="d-flex aling-items-center">
                                    <i :class="apostila.iconClass" class="d-flex align-items-center"></i>
                                    <span class="ml-2">{{ apostila.name }}</span>
                                  </div>
                                </b-card>
                              </transition>
                            </router-link>
                          </div>
                        </div>
                      </b-card-body>
                    </b-card>
                  </b-collapse>
                </div>
                <div v-if="menu.name == 'Exercícios Regionais'">
                  <b-collapse v-model="collapsedStates.exerciciosRegionais[idx]">
                    <div class="p-3">
                      <b-row>
                        <b-col cols="12" v-for="(book, idx) in turma.books" :key="idx" class="mt-2">
                          <router-link :to="{
                            name: 'render-conteudo-exclusivo',
                            params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                            query: { material: formatParam(book.description) },
                          }">
                            <b-card no-body class="p-3 text-dark">
                              <div class="d-flex aling-items-center">
                                <i :class="book.iconClass" class="d-flex align-items-center"></i>
                                <span>{{ book.name }}</span>
                              </div>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                  </b-collapse>
                </div>
                </b-card>
              </div>
              <div class="mt-3" v-else>
                <b-card no-body class="mt-2 border-0 shadow-none">
                  <b-row>
                    <b-col cols="12" v-for="(book, i) in menu.books" :key="i" class="mt-2">
                      <router-link :to="{
                        name: 'render-conteudo-exclusivo',
                        params: { paramsForUrl: book.linkFree || '', nomeApostila: book.name || '' },
                        query: { material: formatParam(book.description) },
                      }" v-if="book.linkFree">
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </router-link>
                      <b-link :href="book.linkXls" v-else>
                        <b-card no-body class="p-3 text-dark">
                          <div class="d-flex aling-items-center">
                            <i :class="book.iconClass" class="d-flex align-items-center"></i>
                            <span>{{ book.name }}</span>
                          </div>
                        </b-card>
                      </b-link>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-collapse>
          </div>
        </b-card>
      </b-container>
    </div>
    <div v-else>
      <div class="container">
        <div class="text-center">
          {{ error503 }}
          <p>Você não tem permissão para visualizar este conteúdo.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dash-infantil',
  data() {
    return {
      pageTitle: 'Pré-Vestibular',
      pageSubtitle: '',

      NamePermission: '',
      IndexPermission: '',

      activeIndex: 0,
      activeTab: 0,

      collapsedStates: {
        colecaoCpv: [],
        resolucaoCpv: [],
        exerciciosRegionais: [],
      },

      lists: [
        {
          id: 0,
          name: 'Coleção CPV',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'pre-vestibular-exercicios-regionais',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-pre-vestibular',
          bg__link: 'medio',
          turmas: [
            {
              name: 'Extensivo',
              otherName: '',
              permission: 'segmento-pre-vestibular',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 1',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_1_Extensivo',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 2',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_2_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 3',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_3_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 4',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_4_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_5.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 5',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_5_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_6.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 6',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_6_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_7.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 7',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_7_Extensivo',
                  toolTip: ' ',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/extensivo/Extensivo_Caderno_8.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 8',
                  name: 'Extensivo',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_8_Extensivo',
                  toolTip: ' ',
                },
              ]
            },
            {
              name: 'Intensivo',
              otherName: '',
              permission: 'segmento-pre-vestibular',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/intensivo/INTENSIVO_Ciencias_Naturais.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Intensivo',
                  name: 'Ciências Naturais',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_1_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/intensivo/INTENSIVO_Matematica_Linguagens_e_Ciencias_Humanas.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Intensivo',
                  name: 'Matemática, Linguagens e Ciências Humanas',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_2_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
              ]
            },
            {
              name: 'Semi',
              otherName: '',
              permission: 'segmento-pre-vestibular',
              books: [
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/semi/Semi_Caderno_1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 1',
                  name: 'Semi',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_1_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/semi/Semi_Caderno_2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 2',
                  name: 'Semi',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_2_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/semi/Semi_Caderno_3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 3',
                  name: 'Semi',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_3_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
                {
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkReaOnly: '',
                  linkFree:
                    'pre-vestibular/colecao-cpv/semi/Semi_Caderno_4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/EnsinoMedio/base-ensino-medio-comp-filo-1.png',
                  bundle: 'E_medio',
                  book: 'Caderno 4',
                  name: 'Semi',
                  segment: '1, mc',
                  discipline: 'Filosofia',
                  description: 'Caderno_4_Semi',
                  toolTip: ' ',
                  isbn: 'Material Complementar',
                },
              ]
            },
            
          ]
        },
        {
          id: 1,
          name: 'Programação',
          iconClass: 'fa-solid fa-book fa-sm mr-1',
          link_name: 'pre-vestibular-programacao',
          colorCard: {
            'background-color': '#38aaf3',
            'border:': '1px solid #38aaf3',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-pre-vestibular',
          bg__link: 'infantil',
          books: [
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkFree: 'pre-vestibular/programacao/programacao-_-extensivo-_-2021.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
              bundle: '',
              name: 'Programação - Extensivo',
              segment: 'EXTENSIVO',
              discipline: '',
              description: 'EXTENSIVO',
              toolTip: ' ',
              isbn: 'Programação',
            },
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkFree: 'pre-vestibular/programacao/programacao-_-semi-unificado-_-2021-4.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/tbw_manual_professor.png',
              bundle: '',
              name: 'Programação - Semi',
              segment: 'SEMI',
              discipline: '',
              description: 'SEMI',
              toolTip: ' ',
              isbn: 'Programação',
            },
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkXls:
                'https://new-content-sistema-cpv-public.s3.amazonaws.com/pre-vestibular/xls/programacao-semi-light-1.xls',
              name: 'Semi-light - Download Excel',
            },
          ],
        },
        {
          id: 2,
          name: 'Manual',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'pre-vestibular-manual',
          colorCard: {
            'background-color': '#4ac8aa',
            'border:': '1px solid #4ac8aa',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-pre-vestibular',
          bg__link: 'fundamental-i',
          books: [
            {
              iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
              linkReaOnly: '',
              linkFree: 'pre-vestibular/manual/manual-coodenador.pdf',
              videoId: '',
              src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/fund1/base-fund1-manual-coordenador.png',
              bundle: '',
              name: 'Manual de Orientações para o Coordenador',
              segment: '1,2,3',
              discipline: '',
              description: 'Manual de Orientações',
              toolTip: '',
              isbn: 'Manual',
            },
          ],
        },
        {
          id: 3,
          name: 'Resoluções',
          iconClass: 'fa-solid fa-file-circle-check fa-sm mr-1',
          link_name: 'pre-vestibular-resolucoes',
          colorCard: {
            'background-color': '#a7dc48',
            'border:': '1px solid #a7dc48',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-pre-vestibular',
          bg__link: 'fundamental-ii',
          turmas: [
            {
              name: 'Matemática',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  bookName: 'Caderno 2',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-2/matext09r-funcoes.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext09R_ Funções',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext09R_ funcoes ',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree:
                        'pre-vestibular/resolucoes/matematica/caderno-2/matext10r-fatoriais-numeros-binomiais-binomio-de-newton-e-analise-combinatoria-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext10R_ Fatoriais N. Binomiais Binômio de Newton e Análise Combinatória',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext10R_ fat binomiais bino de newton e anali combinatoria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },

                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-2/matext11r-geometria-plana-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext11R_ Geometria Plana',
                      book_num: 'Caderno 2',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext11R_ geometria plana',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '2',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 3',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree:
                        'pre-vestibular/resolucoes/matematica/caderno-3/matext12r-as-funcoes-de-2o-grau-ou-funcoes-quadraticas.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext12R_ Funções de 2º Grau',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext12R_ funcoes de 2o grau',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },

                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-3/matext13r-probabilidades.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext13R_ Probabilidades',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext13R_ probabilidades',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-3/matext14r-razao-e-proporcao-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext14R_ Razão e Proporção',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext14R_ razao e proporcao',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-3/matext15r-porcentagem-e-juros-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext15R_ Porcentagem e Juros',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext15R_ porcentagem e juros',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-3/matext16r-trigonometria-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext16R_ Trigonometria',
                      book_num: 'Caderno 3',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext16R_ trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '3',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 4',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext17r-funcoes-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext17R_ Funções',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext17R_ funcoes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext18r-modulo-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext18R_ Módulo',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext18R_ modulo',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext19r-matrizes-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext19R_ Matrizes',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext19R_ matrizes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext20r-determinantes.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext20R_ Determinantes',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext20R_ determinantes',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext21r-sistemas-lineares.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext21R_ Sistemas Lineares',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext21R_ sistemas lineares',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-4/matext22r-geometria-plana-1.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext22R_ Geometria Plana',
                      book_num: 'Caderno 4',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext22R_ geometria plana',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '4',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 5',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-5/matext23r-exponenciais.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext23R_ Exponenciais',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext23R_ exponenciais',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-5/matext24r-trigonometria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext24R_ Trigonometria',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext24R_ trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-5/matext25r-_-geometria-espacial.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext25R_ Geometria Espacial',
                      book_num: 'Caderno 5',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext25R_ geometria espacial',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '5',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 6',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-6/matext26r-logaritmos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext26R_ Logaritmos',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext26R_ logaritmos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-6/matext27r-trigonometria.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext27R_ Trigonometria',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext27R_ trigonometria',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree:
                        'pre-vestibular/resolucoes/matematica/caderno-6/matext28r-geometria-analitica-o-ponto-e-a-reta.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext28R_ Geometria Analítica',
                      book_num: 'Caderno 6',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext28R_ geometria analitica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '6',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 7',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-7/matext29r-_-logaritmos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext29R_ Logaritmos',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext29R_ logaritmos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-7/matext30r-_-polinomios.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext30R_ Polinômios',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext30R_ polinomios',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-7/matext31r-geometria-analitica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext31R_ Geometria Analítica',
                      book_num: 'Caderno 7',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext31R_ geometria analitica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '7',
                    },
                  ],
                },
                {
                  bookName: 'Caderno 8',
                  apostila: [
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-8/matext32r-_-numeros-complexos.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext32R_ Números Complexos',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext32R_ numeros complexos',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },
                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree:
                        'pre-vestibular/resolucoes/matematica/caderno-8/matext33r-_-equacoes-algebricas-ou-polinomiais.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext33R_ Equações Algébricas ou Polinomiais',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext33R_ equacoes elgebricas ou polinomiais',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },

                    {
                      linkReaOnly: '',
                      iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                      linkFree: 'pre-vestibular/resolucoes/matematica/caderno-8/matext34r-_-geometria-analitica.pdf',
                      videoId: '',
                      src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-laranja.png',
                      bundle: '',
                      name: 'matext34R_ Geometria Analítica',
                      book_num: 'Caderno 8',
                      segment: '',
                      discipline: 'Matemática',
                      description: 'matext34R_ geometria analitica',
                      toolTip: '',
                      isbn: 'Resoluções - Caderno ',
                      numeral: '8',
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 4,
          name: 'Exercícios Regionais',
          iconClass: 'fa-solid fa-notebook fa-sm mr-1',
          link_name: 'pre-vestibular-exercicios-regionais',
          colorCard: {
            'background-color': '#fc5b5b',
            'border:': '1px solid #fc5b5b',
            'border-radius': '0.5rem',
          },
          permission: 'segmento-pre-vestibular',
          bg__link: 'medio',
          turmas: [
            {
              name: 'Minas Gerais',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmghib0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'História do Brasil',
                  segment: '',
                  discipline: 'HISTÓRIA DO BRASIL',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmghig0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'História Geral',
                  segment: '',
                  discipline: 'HISTÓRIA GERAL',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmging0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Língua Inglesa',
                  segment: '',
                  discipline: 'LÍNGUA INGLESA',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmggra0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Língua Portuguesa',
                  segment: '',
                  discipline: 'LÍNGUA PORTUGUESA',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmglit0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Literatura',
                  segment: '',
                  discipline: 'LITERATURA',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmgmat0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Matemática',
                  segment: '',
                  discipline: 'MATEMÁTICA',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exquimg0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Química',
                  segment: '',
                  discipline: 'QUÍMICA',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/minas-gerais/exmgred0108.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Redação',
                  segment: '',
                  discipline: 'REDAÇÃO',
                  description: 'Exercícios Regionais • Minas Gerais',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'MG',
                },
              ],
            },
            {
              name: 'Rio de Janeiro',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/biologia.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Biologia',
                  segment: '',
                  discipline: 'BIOLOGIA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/fisica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Física',
                  segment: '',
                  discipline: 'FÍSICA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/geografia-do-brasil.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geografia do Brasil',
                  segment: '',
                  discipline: 'GEOGRAFIA DO BRASIL',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/geografia-geral.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geografia Geral',
                  segment: '',
                  discipline: 'GEOGRAFIA GERAL',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/historia-do-brasil.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'História do Brasil',
                  segment: 'HISTÓRIA DO BRASIL',
                  discipline: '',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/historia-geral.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'História Geral',
                  segment: '',
                  discipline: 'HISTÓRIA GERAL',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/ingles.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Língua Inglesa',
                  segment: '',
                  discipline: 'LÍNGUA INGLESA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/gramatica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Gramática',
                  segment: '',
                  discipline: 'GRAMÁTICA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/literatura.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Literatura',
                  segment: '',
                  discipline: 'LITERATURA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/matematica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Matemática',
                  segment: '',
                  discipline: 'MATEMÁTICA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/quimica.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Química',
                  segment: '',
                  discipline: 'QUÍMICA',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/rio-de-janeiro/redacao.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Redação',
                  segment: '',
                  discipline: 'REDAÇÃO',
                  description: 'Exercícios Regionais • Rio de Janeiro',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'RJ',
                },
              ],
            },
            {
              name: 'Sul',
              otherName: '',
              permission: 'segmento-ensino-medio',
              books: [
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/sul/exercicios-regiao-sul-caderno-1.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geral - Caderno 1',
                  segment: '',
                  discipline:
                    'MATEMÁTICA, QUIMÍCA, BIOLOGIA, LÍNGUA PORTUGUESA, LITERATURA, REDAÇÃO, HISTÓRIA GERAL, HISTÓRIA DO BRASIL, GEOGRAFIA DO BRASIL, GEOGRAFIA GERAL ',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'Sul',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/sul/exercicios-regiao-sul-caderno-2.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geral - Caderno 2',
                  segment: '',
                  discipline:
                    'MATEMÁTICA, FÍSICA, QUIMÍCA, BIOLOGIA, LÍNGUA PORTUGUESA, LITERATURA, HISTÓRIA GERAL, HISTÓRIA DO BRASIL, GEOGRAFIA DO BRASIL, GEOGRAFIA GERAL ',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'Sul',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/sul/exercicios-regiao-sul-caderno-3.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geral - Caderno 3',
                  segment: '',
                  discipline:
                    'MATEMÁTICA, FÍSICA, QUIMÍCA, BIOLOGIA, LÍNGUA PORTUGUESA, LITERATURA, HISTÓRIA GERAL, HISTÓRIA DO BRASIL, GEOGRAFIA DO BRASIL, GEOGRAFIA GERAL ',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'Sul',
                },
                {
                  linkReaOnly: '',
                  iconClass: 'fa-light fa-chalkboard-user mr-2 fa-sm',
                  linkFree: 'pre-vestibular/exercicios-regionais/sul/exercicios-regiao-sul-caderno-4.pdf',
                  videoId: '',
                  src: 'https://app-sistemacpv.s3.amazonaws.com/thumbsViewer/base-logo-roxo.png',
                  bundle: 'E_medio',
                  name: 'Geral - Caderno 4',
                  segment: '',
                  discipline:
                    'MATEMÁTICA, FÍSICA, QUIMÍCA, BIOLOGIA, LÍNGUA PORTUGUESA, LITERATURA, HISTÓRIA GERAL, HISTÓRIA DO BRASIL, GEOGRAFIA DO BRASIL, GEOGRAFIA GERAL, LÍNGUA INGLESA ',
                  description: 'Exercícios Regionais • SUL',
                  toolTip: '',
                  isbn: 'Vestibulares',
                  numeral: '',
                  sigla: 'Sul',
                },
              ],
            },
          ],
        },
      ],
    }
  },

  created() {
    this.$emit('update-header', {
      title: this.pageTitle,
      subtitle: this.pageSubtitle,
    })
  },

  computed: {
    permissions() {
      return this.$store.state.auth.userpermissions.permissions
    },
    // error503() {
    //   return (window.location.href = '/nao-autorizado');
    // },
  },

  methods: {
    temPermissao(permissao) {
      return this.permissions.includes(permissao)
    },

    isToggleMaternalI() {
      this.isMaternalICollapsed = !this.isMaternalICollapsed
    },

    setActive(index) {
      this.activeIndex = index
    },

    clearActive(index) {
      if (this.activeIndex === index) {
        this.activeIndex = []
      }
    },

    toggleCollapse(type, idx) {
      if (!Array.isArray(this.collapsedStates[type])) {
        this.$set(this.collapsedStates, type, [])
      }

      this.collapsedStates[type].forEach((_, index) => {
        this.$set(this.collapsedStates[type], index, index === idx ? !this.collapsedStates[type][idx] : false)
      })
    },

    formatParam(param) {
      return param.replace(/\s+/g, '-')
    },
  },
}
</script>

<style scoped>
.nav-books {
  padding: 0.5rem 0.5rem;
}

.nav-books span {
  color: #3A1C53;
}

.nav-books i {
  color: #E98B24;
}

.card_sistemacpv {
  border-radius: 8px;
  color: #3A1C53;
}

.button-toggle {
  background-color: rgba(248, 249, 250, 0.45);
}

.button-toggle span strong {
  color: #3A1C53;
}

.button-toggle i {
  color: #E98B24;
}

.border-bottom {
  border-color: 1px solid #dee2e6 !important;
}

.title-collapse {
  color: #3A1C53;
}

.nav-cadernos {
  color: #3a1c53;
  font-weight: 600;
  padding: 0.5rem 0.5rem;
}

.nav-cadernos.active {
  color: #E98B24 !important;
}
</style>
